export default "__VITE_ASSET__$zfEJ5bx__"